import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

const steps = [
  {
    icon: <SearchOutlinedIcon fontSize="large" />,
    title: 'Explora el catálogo',
    description: 'Busca por nombre o navega los productos disponibles, con stock en tiempo real.',
  },
  {
    icon: <AddShoppingCartOutlinedIcon fontSize="large" />,
    title: 'Agrega al carrito',
    description: 'Elige la cantidad de cada producto; tu carrito se guarda aunque cierres la página.',
  },
  {
    icon: <CreditCardOutlinedIcon fontSize="large" />,
    title: 'Paga como invitado o con cuenta',
    description: 'No necesitas registrarte: solo tu nombre y correo para completar la compra.',
  },
  {
    icon: <ReceiptLongOutlinedIcon fontSize="large" />,
    title: 'Recibe tu comprobante',
    description: 'Emite tu boleta o factura al instante y descárgala o recíbela por correo.',
  },
];

// Guia estatica de "como comprar": no depende de datos del backend, solo orienta al
// cliente sobre el flujo catalogo -> carrito -> checkout -> comprobante ya implementado.
export default function BuyingGuideSection() {
  return (
    <Box sx={{ bgcolor: 'background.neutral', py: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Stack spacing={1} sx={{ alignItems: 'center', mb: 5, textAlign: 'center' }}>
          <Typography variant="h4">¿Cómo comprar?</Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 560 }}>
            De la elección de tus productos a tu comprobante de pago, en cuatro pasos simples.
          </Typography>
        </Stack>

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid key={step.title} size={{ xs: 12, sm: 6, md: 3 }}>
              <Stack sx={{ alignItems: 'center', textAlign: 'center' }} spacing={1.5}>
                <Box
                  sx={{
                    position: 'relative',
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    bgcolor: 'primary.lighter',
                    color: 'primary.dark',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {step.icon}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      width: 26,
                      height: 26,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      color: 'primary.contrastText',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 13,
                      fontWeight: 700,
                    }}
                  >
                    {index + 1}
                  </Box>
                </Box>
                <Typography variant="h6">{step.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {step.description}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Stack sx={{ alignItems: 'center', mt: 5 }}>
          <Button component={RouterLink} to="/catalogo" variant="contained" size="large">
            Empezar a comprar
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
